module.exports = __webpack_public_path__ + "img/section.a29a57e8.png";